import { Route, Routes } from "react-router-dom";
import Admin from "./layouts/admin";
import NotFound from "./views/Error/notFound";
import Login from "./views/Auth/login";
import Agendas from "./views/Agenda/index";
import Home from "./views/Main/home";
import ActivitiesByAppointment from "./views/Activities/ActivitiesByAppointment/index";
import SchedulingAgendas from "./views/Scheduling_Agendas/schedulingAgendas";
import CompetitorsByAppointment from "./views/Activities/competitorsByAppointment";
import SurveyByAppointment from "./views/Activities/surveyByAppointment";
import InventoryAppointment from "./views/Activities/inventoryAppointment";
import PricesAppointment from "./views/Activities/pricesAppointment";
import VisualExecutionInventory from "./views/Activities/visualExecutionInventory";
import PrivateRoutes from "./utils/PrivateRoutes";
import ShareOfShelf from "./views/Activities/shareOfShelf";
import SalesAppointment from "./views/Activities/salesAppointment";
import PosLayout from "./views/Activities/posLayoutAppointment";
import FeedBack from "./views/Activities/feedBack";
import Courses from "./views/Learning/courses";
import Colleagues from "./views/Learning/colleagues";
import TrainingLibrary from "./views/Learning/trainingLibrary";
import Emblems from "./views/Learning/emblems";
import ClosingSalesAppointment from "./views/Activities/closingSalesAppointment";
import StockOutAppointment from "./views/Activities/stockOutAppointment";
import EsfCoverageAppointment from "./views/Activities/esfCoverageAppointment";
import ServedClients from "./views/Activities/servedClientsAppointment";
import SchedulingAgedasFiles from "./views/Scheduling_Agendas/schedulingAgendasFiles";
import Users from "./views/UserManagement/users";
import ActivationsCreation from "./views/Activations/activationsCreation";
import ActivationsAssignation from "./views/Activations/activationsAssingation";
import Attendance from "./views/Attendance/attendance";
import SellOut from "./views/SellOut/sellOut";
import Brands from "./views/Brands/brands";
import Surveys from "./views/Surveys/surveys";
import VisualExecution from "./views/VisualExecution/visualExecution";
import ExecutionManagement from "./views/ExecutionManagement/executionManagement";
import Reports from "./views/Reports/Reports";
import CoursesManagement from "./views/CoursesManagement/coursesManagement";
import CreatePOS from "./views/POSSalesManagement/CreatePOS";
import UpdatePOS from "./views/POSSalesManagement/UpdatePOS";
import POSManagementMain from "./views/POSSalesManagement/POSManagementMain";
import Scorecard from "./views/SellOut/scoreCard";
import SubRetailManagementMain from "./views/SubRetailManagement/SubRetailMainScreen";
import Metrics from "./views/Metrics/metrics";
import Absences from "./views/Absences/absences";
import ActivationAssignationScreen from "./views/Activations/ActivationAssignation/activationAssignationScreen";
import { RootState } from "./app/store";
import { useSelector } from "react-redux";
import { ModulesEnum } from "../src/models/enum/ModulesEnum";
import { Item } from "../src/features/routeState/useRouteState";
import TrainingMaterial from "./views/TrainingMaterial/trainingMaterial";
import ProductsManagement from "./views/ProductsManagement/productsManagement";
import MetricsRealTime from "./views/Metrics/metricsRealTime";
import MetricsRanking from "./views/Metrics/metricsRanking";
import SupportActivity from "./views/Support/SupportActivity";
import AppointmentControl from "./views/Appointment/appointmentControl";
import UsersManagementMassive from "./views/UserManagement/usersManagementMasssive";
import AbsencesMassive from "./views/Absences/absencesMassive";
import AttendanceRoute from "./views/Attendance/attendanceRoute";
import CheckInVsAbsence from "./views/CheckInVsAbsence/CheckInVsAbsence"
import JustificationAbsences from "./views/JustificationAbsences/justificationAbsences";
import BulkActivationAssignment from "./views/Activations/bulkActivationAssignment";

export default function App() {
  const enableroute: any[] = useSelector(
    (state: RootState) => state.enableRoute.enabled
  );

  return (
    <Routes>
      <Route path="/login" element={<Login />}></Route>

      <Route path="/" element={<PrivateRoutes />}>
        <Route path="/" element={<Admin />}>
          <Route path="/" element={<Home />}></Route>

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.AgendaTab
          ) && <Route path="/agendas" element={<Agendas />}></Route>}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.UserManagement
          ) && <Route path="/users" element={<Users />}></Route>}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.usersManagementMassive
          ) && (
            <Route
              path="/users_management_massive"
              element={<UsersManagementMassive />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.ActivationManagement
          ) && (
            <>
              <Route
                path="/activations"
                element={<ActivationsCreation />}
              ></Route>
              <Route
                path="/activationsAssignation"
                element={<ActivationAssignationScreen />}
              ></Route>
              <Route
                path="/bulkActivationsAssignation"
                element={<BulkActivationAssignment />}
              ></Route>
            </>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.AgendaManagement
          ) && (
            <>
              <Route
                path="/scheduling_agendas"
                element={<SchedulingAgendas />}
              ></Route>
            </>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.AgendaManagementFiles
          ) && (
            <Route
              path="/scheduling_agendas_files"
              element={<SchedulingAgedasFiles />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.LearningTab
          ) && (
            <>
              <Route path="/courses" element={<Courses />}></Route>
              <Route path="/colleagues" element={<Colleagues />}></Route>
              <Route path="/emblems" element={<Emblems />}></Route>
              <Route
                path="/trainingLibrary"
                element={<TrainingLibrary />}
              ></Route>
            </>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.BrandsTab
          ) && <Route path="/brands" element={<Brands />}></Route>}

          {enableroute[0]?.some((e: Item) => e.id === ModulesEnum.SellOut) && (
            <>
              <Route path="/sellOut" element={<SellOut />}></Route>
              <Route path="/scorecard" element={<Scorecard />}></Route>
            </>
          )}

          {enableroute[0]?.some((e: Item) => e.id === ModulesEnum.Surveys) && (
            <Route path="/surveys" element={<Surveys />}></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.ExecutionManagement
          ) && (
            <Route
              path="/executionManagement"
              element={<ExecutionManagement />}
            ></Route>
          )}

          {enableroute[0]?.some((e: Item) => e.id === ModulesEnum.Reports) && (
            <Route path="/reports" element={<Reports />}></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.SubRetailManagement
          ) && (
            <>
              <Route
                path="/posManagement"
                element={<POSManagementMain />}
              ></Route>
              <Route
                path="/subRetailManagement"
                element={<SubRetailManagementMain />}
              ></Route>
              <Route path="/createPOS" element={<CreatePOS />}></Route>
              <Route path="/updatePOS" element={<UpdatePOS />}></Route>
            </>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.AttendanceControl
          ) && (
            <>
              <Route path="/attendance" element={<Attendance />}></Route>
              <Route
                path="/attendanceRoute"
                element={<AttendanceRoute />}
              ></Route>
            </>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.VisualExecution
          ) && (
            <Route
              path="/visualExecution"
              element={<VisualExecution />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.CourseManagement
          ) && (
            <Route
              path="/coursesManagement"
              element={<CoursesManagement />}
            ></Route>
          )}

          {enableroute[0]?.some((e: Item) => e.id === ModulesEnum.Metrics) && (
            <Route path="/metrics" element={<Metrics />}></Route>
          )}

          {enableroute[0]?.some((e: Item) => e.id === ModulesEnum.Absences) && (
            <Route path="/absences" element={<Absences />}></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.AbsencesMassive
          ) && (
            <Route
              path="/massive-absences"
              element={<AbsencesMassive />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.JustificationAbsences
          ) && (
            <Route
              path="/justification-absences"
              element={<JustificationAbsences />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.TrainingMaterial
          ) && (
            <Route
              path="/trainingMaterial"
              element={<TrainingMaterial />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.ProductsManagement
          ) && (
            <Route
              path="/productsManagement"
              element={<ProductsManagement />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.MetricsRealTime
          ) && (
            <Route
              path="/metricsRealTime"
              element={<MetricsRealTime />}
            ></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.MetricsRanking
          ) && (
            <Route path="/metricsRanking" element={<MetricsRanking />}></Route>
          )}

          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.AppointmentControl
          ) && (
            <Route
              path="/appointmentControl"
              element={<AppointmentControl />}
            ></Route>
            )}
          
          {enableroute[0]?.some(
            (e: Item) => e.id === ModulesEnum.CheckInVsAbsence
          ) && (
            <Route
              path="/checkInVsAbsence"
              element={<CheckInVsAbsence />}
            ></Route>
          )}

          <Route
            path="/activitiesByAppointment/:id"
            element={<ActivitiesByAppointment />}
          ></Route>

          <Route
            path="/surveyByAppointment/:id/:activityId"
            element={<SurveyByAppointment />}
          ></Route>

          <Route
            path="/competitorsByAppointment/:id/:activityId"
            element={<CompetitorsByAppointment />}
          ></Route>
          <Route
            path="/visualExecutionInventory/:id/:activityId"
            element={<VisualExecutionInventory />}
          ></Route>
          <Route
            path="/shareOfShelf/:id/:activityId"
            element={<ShareOfShelf />}
          ></Route>
          <Route
            path="/inventoryAppointment/:activityId/:id"
            element={<InventoryAppointment />}
          ></Route>
          <Route
            path="/pricesAppointment/:activityId/:id"
            element={<PricesAppointment />}
          ></Route>
          <Route
            path="/salesAppointment/:activityId/:id"
            element={<SalesAppointment />}
          ></Route>
          <Route
            path="/posLayoutAppointment/:activityId/:id"
            element={<PosLayout />}
          ></Route>
          <Route
            path="/feedBack/:id/:activityId"
            element={<FeedBack />}
          ></Route>

          <Route
            path="/closingSalesAppointment/:activityId/:id"
            element={<ClosingSalesAppointment />}
          ></Route>
          <Route
            path="/stockOutAppointment/:activityId/:id"
            element={<StockOutAppointment />}
          ></Route>
          <Route
            path="/esfCoverageAppointment/:activityId/:id"
            element={<EsfCoverageAppointment />}
          ></Route>
          <Route
            path="/servedClientsAppointment/:activityId/:id"
            element={<ServedClients />}
          ></Route>
          <Route path="/support" element={<SupportActivity />}></Route>

          {/* <Route path="/activationAssignation" element={<ActivationAssignationScreen/>} ></Route> */}
        </Route>

        <Route element={<NotFound />} path="*"></Route>
      </Route>
    </Routes>
  );
}
